<div class="carousel-wrapper-parent">
  <div class="bg-img"></div>
  <div class="login-page">
    <div>
      <div class="login-wrapper-update">
        <div>
          <div class="backBtn">
            <img src="/assets/img/3ddv/3ddv_black.png" />
          </div>
          <div class="login-wrapper-body">
            <div class="mb-2">
              <span class="input-label">OTP Token</span>
            </div>
            <input
              type="text"
              class="email-input mb-4"
              name="otpToken"
              id="floatingInput"
              [(ngModel)]="credentials.otpToken" />
            <div class="mb-2">
              <span class="input-label">New Password</span>
            </div>
            <input
              type="password"
              class="email-input"
              name="updatePassword"
              id="floatingPassword"
              [(ngModel)]="credentials.password" />
            <div id="passwordHelpBlock" class="form-text mb-4">
              The password must be at least 15 characters long. <br />
              The password must contain mix of at least three of following: uppercase, lowercase, number and special
              characters
            </div>
            <div class="mb-2">
              <span class="input-label">Repeat New Password</span>
            </div>
            <input
              type="password"
              class="email-input"
              name="updatePassword2"
              id="floatingPassword2"
              [(ngModel)]="credentials.password2" />
            <div class="alert alert-danger mt-2" role="alert" *ngIf="errmsg">
              {{ errmsg }}
            </div>
          </div>

          <div class="login-wrapper-bottom">
            <button class="btn-login-main reset-password-btn" type="submit" (click)="update()">Update Password</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
